import styles from './styles.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck,
  faCircleExclamation,
  faRotateRight,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';
import { getCalcStatusText } from '../../../services/getCalcStatusText';
import { add, format } from 'date-fns';
import { CalcStatus as StatusType, Contract } from '../../../types/contracts';

/**
 * 「XXX 以降」のテキストを出す表示する計算状態
 * @see https://fenrir-inc.backlog.com/view/MRBN_UR_INHOUSE-603#comment-319284186
 */
const showInvalidStatuses: StatusType[] = ['incomplete', 'partComplete'];

type Props = Pick<
  Contract,
  'calcStatus' | 'calcValidDate' | 'collectionConstraintTypeId'
>;

function CalcStatus({
  calcStatus,
  calcValidDate,
  collectionConstraintTypeId,
}: Props) {
  return (
    <div className={styles.host}>
      {calcStatus === 'completed' ? (
        <FontAwesomeIcon icon={faCheck} className={styles.good} />
      ) : calcStatus === 'updateContract' ? (
        <FontAwesomeIcon icon={faRotateRight} className={styles.updated} />
      ) : (
        <FontAwesomeIcon icon={faCircleExclamation} className={styles.ng} />
      )}
      <div className={styles.statusText}>{getCalcStatusText(calcStatus)}</div>
      {showInvalidStatuses.includes(calcStatus) &&
        isInvalidDateShow(collectionConstraintTypeId) &&
        calcValidDate && (
          <div className={styles.invalid}>
            {invalidStart(calcValidDate)}
            <FontAwesomeIcon icon={faXmark} className={styles.invalidIcon} />
          </div>
        )}
    </div>
  );
}

export default CalcStatus;

function isInvalidDateShow(
  id: Contract['collectionConstraintTypeId']
): boolean {
  return id === /* 「定期」 */ 1;
}

function invalidStart(calcValidDate: string): string {
  const start = add(new Date(calcValidDate), { days: 1 });
  return `${format(start, 'yyyy/M/d')}以降 `;
}
